module.exports = __webpack_public_path__ + "static/media/m8tj0.5d31f843.png";